import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Quote } from 'lucide-react';

const TestimonialCard = ({ testimonial, index, darkMode }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay: index * 0.2 }}
      className={`${darkMode ? 'bg-slate-900' : 'bg-slate-50'} p-10 rounded-2xl shadow-lg`}
    >
      <Quote className={`w-10 h-10 ${darkMode ? 'text-slate-700' : 'text-slate-300'} mb-6`} />
      <blockquote className={`text-2xl ${darkMode ? 'text-slate-300' : 'text-slate-700'} mb-6 leading-relaxed italic`}>
        "{testimonial.text}"
      </blockquote>
      <div>
        <div className={`${darkMode ? 'text-white' : 'text-slate-900'} font-bold text-lg`}>{testimonial.name}</div>
        <div className={`${darkMode ? 'text-slate-400' : 'text-slate-600'}`}>{testimonial.role}</div>
      </div>
    </motion.div>
  );
};

export default TestimonialCard;